module.exports = __webpack_public_path__ + "img/icon-confetti.30b4929a.svg";